import { defaultTheme } from 'react-admin';
import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  ...defaultTheme,
  layout: {
    pageWidth: 1440,
  },
});
